import {
  PaymentStatus,
  paymentStatusDisplayNames,
} from "@/common/enum/payment-status";
import {
  PaymentType,
  paymentTypeDisplayNames,
} from "@/common/enum/payment-type";

import { formatDateToYYYYMMDDhhmm9 } from "@/common/util/date-util";
import { formatNumber } from "@/common/util/format-number-with-commas";
import { FileCopyOutlineIcon } from "@/components/icon/FileCopyOutlineIcon";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Strong } from "@/components/typography/Body14Strong";
import { OrderDetailDto } from "@/types/dto/order-detail-dto";
import { Table } from "flowbite-react";

interface Props {
  orderDetail: OrderDetailDto;
}

export const PartnerCompleteOrderPaymentTableRow: React.FC<Props> = ({
  orderDetail,
}) => {
  const payment = orderDetail.payment;
  console.log("orderDetail", orderDetail);
  console.log("payment", payment);

  // const vertualAccount = "신한은행 140-014-327272 아카라라이프(주)";
  const vertualAccount = `${payment.extraDataVC?.bankname} ${
    payment.extraDataVC?.account ?? ""
  }`;

  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(vertualAccount);
      window.confirm("계좌번호가 복사되었습니다.");
    } catch (error) {
      console.error("Failed to copy: ", error);
      window.confirm("계좌번호 복사에 실패했습니다.");
    }
  };

  return (
    <Table.Row className="bg-white text-semantic-text-body">
      <Table.Cell>
        {payment.paymentMethod === PaymentType.PAVC ? (
          <div className="flex flex-col gap-[4px] p-[16px]">
            <Body14Regular>
              {paymentTypeDisplayNames[payment.paymentMethod]}
            </Body14Regular>
            {payment.status === PaymentStatus.PENDING && (
              <div
                className="flex gap-[4px] items-center cursor-pointer"
                onClick={handleCopyClick}
              >
                <Body14Strong>입금계좌</Body14Strong>
                <Body14Regular>{vertualAccount}</Body14Regular>
                <FileCopyOutlineIcon
                  size={16}
                  color="text-grayscale-contrast-60"
                />
              </div>
            )}
            {payment.status === PaymentStatus.PENDING &&
              payment.extraDataVC && (
                <Body14Regular className="text-semantic-text-error-primary">
                  1일 이내 미입금 시 주문이 자동 취소됩니다.
                </Body14Regular>
              )}
          </div>
        ) : (
          <Body14Regular className="p-[16px]">
            {paymentTypeDisplayNames[payment.paymentMethod]}
            {payment.paymentMethod === PaymentType.PALT && (
              <Body14Regular className="text-semantic-text-error-primary">
                익월 5영업일 내 세금계산서 발행 예정
              </Body14Regular>
            )}
          </Body14Regular>
        )}
      </Table.Cell>
      <Table.Cell className="border-l">
        <Body14Regular className="p-[16px]">
          {formatNumber(payment.amount)}원
        </Body14Regular>
      </Table.Cell>
      <Table.Cell className="border-l">
        <div className="flex flex-col justify-center p-[16px]">
          <Body14Regular
            className={
              payment.status === PaymentStatus.PENDING
                ? "text-semantic-text-error-primary"
                : "text-semantic-text-body"
            }
          >
            {paymentStatusDisplayNames[payment.status]}
          </Body14Regular>
          {payment.status === PaymentStatus.COMPLETED &&
            payment.completedAt && (
              <Body14Regular className="text-semantic-text-tertiary">
                {formatDateToYYYYMMDDhhmm9(payment.completedAt)}
              </Body14Regular>
            )}
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
